export const SET_USER = 'AUTH_USER';
export const SET_TOKEN = 'AUTH_TOKEN';
export const SET_MSG = 'AUTH_MSG';
export const SET_CONFIGURACAOGERAL = 'AUTH_CONFIGURACAOGERAL';
export const SET_EDITAR = 'USER_EDITAR';
export const SET_LISTANOTIFICACAO = 'AUTH_LISTANOTIFICACAO';